import { makeStyles } from "@material-ui/core/styles";
import { DeliveriesStatus } from "@saleor/types/globalTypes";
import React from "react";

export interface ThreePlStatusProps {
  status: DeliveriesStatus | null;
}

const useStyles = makeStyles(
  () => ({
    cancelledDeliveryStatusLabel: {
      color: "#EC5D77",
      fontSize: "16px",
      fontWeight: 500
    },
    deliveryStatusLabel: {
      color: "#000000",
      fontSize: "14px",
      fontWeight: 500
    },
    successDeliveryStatusLabel: {
      color: "#00C6A2",
      fontSize: "14px",
      fontWeight: 500
    }
  }),
  { name: "ThreePlStatus" }
);

const ThreePlStatus: React.FC<ThreePlStatusProps> = ({ status }) => {
  const classes = useStyles({});
  let newLabel = "";

  switch (status) {
    case DeliveriesStatus.TP_2GO_TO_SEND:
      newLabel = "Send";
      break;
    case DeliveriesStatus.TP_2GO_SENT:
      newLabel = "Sent";
      break;
    case DeliveriesStatus.TP_2GO_SERVED:
      newLabel = "Served";
      break;
    case DeliveriesStatus.TP_2GO_UNSERVED:
      newLabel = "Unserved";
      break;
    case DeliveriesStatus.TP_2GO_CANCELLED:
      newLabel = "Cancelled";
      break;
    case DeliveriesStatus.TP_2GO_ARRIVAL:
      newLabel = "Arrival";
      break;
    case DeliveriesStatus.TP_2GO_OFF_LOADED:
      newLabel = "Off Loaded";
      break;
    case DeliveriesStatus.TP_2GO_ACCEPTANCE:
      newLabel = "Acceptance";
      break;
    case DeliveriesStatus.TP_2GO_LOADED:
      newLabel = "Loaded";
      break;
    case DeliveriesStatus.TP_2GO_OUT_FOR_DELIVERY:
      newLabel = "Out for delivery";
      break;
    case DeliveriesStatus.TP_2GO_ON_FORWARDED:
      newLabel = "Forwarded";
      break;
    case DeliveriesStatus.TP_2GO_ON_HOLD:
      newLabel = "On hold";
      break;
    case DeliveriesStatus.TP_2GO_IN_TRANSIT:
      newLabel = "In transit";
      break;
    case DeliveriesStatus.TP_2GO_CONSIGNEE_NOT_AROUND:
      newLabel = "Consignee not around";
      break;
    case DeliveriesStatus.TP_2GO_REFUSED_TO_ACCEPT:
      newLabel = "Refused to accept";
      break;
    case DeliveriesStatus.TP_2GO_REFUSED_TO_PAY:
      newLabel = "Refused to pay";
      break;
    case DeliveriesStatus.TP_2GO_RETURNED_TO_SENDER:
      newLabel = "Returned to sender";
      break;
    case DeliveriesStatus.TP_2GO_RETURNED_TO_CUSTOMER:
      newLabel = "Returned to customer";
      break;
    case DeliveriesStatus.TP_2GO_DELIVERED:
      newLabel = "Delivered";
      break;
    case DeliveriesStatus.TP_2GO_FLOODED_AREA:
      newLabel = "Flooded area";
      break;
    case DeliveriesStatus.TP_2GO_HOLD_TRANSACTION:
      newLabel = "Hold transaction";
      break;
    case DeliveriesStatus.TP_2GO_BUSINESS_CLOSED:
      newLabel = "Business closed";
      break;
    case DeliveriesStatus.TP_2GO_INVOICE_FOR_CHECKING:
      newLabel = "Invoice for checking";
      break;
    case DeliveriesStatus.TP_2GO_RESIDENCE_CLOSED:
      newLabel = "Residence closed";
      break;
    case DeliveriesStatus.TP_2GO_ROAD_CLOSED:
      newLabel = "Closed";
      break;
    case DeliveriesStatus.TP_2GO_PAYMENT_NOT_READY:
      newLabel = "Payment not ready";
      break;
    case DeliveriesStatus.TP_2GO_TRANSFERRED:
      newLabel = "Transferred";
      break;
    case DeliveriesStatus.TP_2GO_UNKNOWN_CONSIGNEE:
      newLabel = "Unknown consignee";
      break;
    case DeliveriesStatus.TP_2GO_LOST_CARGO:
      newLabel = "Lost cargo";
      break;
    case DeliveriesStatus.TP_2GO_NO_SHOW:
      newLabel = "No show";
      break;
    case DeliveriesStatus.TP_2GO_OFFICE_CLOSED:
      newLabel = "Office closed";
      break;
    case DeliveriesStatus.TP_2GO_MISROUTED:
      newLabel = "Misrouted";
      break;
    case DeliveriesStatus.TP_2GO_BAD_ADDRESS:
      newLabel = "Bad address";
      break;
    case DeliveriesStatus.TP_2GO_WITH_FILED_CLAIMS:
      newLabel = "With filed claims";
      break;
    default:
      break;
  }

  const checkStatus = () => {
    switch (status) {
      case DeliveriesStatus.TP_2GO_DELIVERED:
        return (
          <div>
            <span className={classes.successDeliveryStatusLabel}>
              {newLabel}
            </span>
          </div>
        );
      case DeliveriesStatus.TP_2GO_CANCELLED:
        return (
          <div>
            <span className={classes.cancelledDeliveryStatusLabel}>
              {newLabel}
            </span>
          </div>
        );
      default:
        return (
          <div>
            <span className={classes.deliveryStatusLabel}>{newLabel}</span>
          </div>
        );
    }
  };
  return checkStatus();
};

export default ThreePlStatus;
